import { useQuery } from "@apollo/client";

import { SettingsResearchTypeEditRoute_GetByIdDocument } from "../queries.generated";

export default function useSettingsResearchTypeEditRoute_GetById(researchTypeId: string) {
    const { data, loading, error } = useQuery(SettingsResearchTypeEditRoute_GetByIdDocument, {
        variables: { id: researchTypeId },
    });

    return {
        researchType: data?.settingsResearchTypeGetById,
        loading,
        error,
    };
}
